export default __webpack_public_path__ + "static/media/kolba_playeronly.fcddd7b5.png";